import React from "react";
import PageHeader from "../components/page-header";
import { Link } from "react-router-dom";
import TDXIntro from "../assets/images/solutions/tdx.png";
import TDXDiagram from "../assets/images/solutions/tdx-diagram.png";

import DiverseContent from "../assets/images/slider/data-exchange/diverse-content.png";
import BuildOwnAdapters from "../assets/images/slider/data-exchange/build-own-adapters.png";
import ReducedCost from "../assets/images/slider/data-exchange/reduced-cost.png";
import ShorterTime from "../assets/images/slider/data-exchange/shorter-time-to-market.png";
import EaseOfDistribution from "../assets/images/slider/data-exchange/ease-of-distribution.png";
import Flexibility from "../assets/images/slider/data-exchange/flexibility.png";
import TrafficVolumes from "../assets/images/slider/data-exchange/traffic-volumes.png";
import MappedHotelInventory from "../assets/images/slider/data-exchange/mapped-hotel-inventory.png";
import FeedManagement from "../assets/images/slider/data-exchange/feed-management.png";

import LowCostAirlines from "../assets/resources/Low-Cost-Airlines-Integrated-by-TravelCarma.pdf";

const SolutionsTravelDataXchange = () => {
  return (
    <div className="page-inside page-booking-engine">
      <PageHeader page="travel-data-xchange" />
      <div className="container">
        <div className="p-5 shadow rounded">
          <h2
            className="text-center mb-5 text-primary"
            style={{ fontSize: "28px" }}
          >
            Enterprise Travel Connectivity at Scale
          </h2>
          <p className="text-center">
            OTAs, consolidators, TMCs, and DMCs need to aggregate diverse supplier content while maintaining operational control, data quality, and integration flexibility.
          </p>
          <p className="text-center mb-0">
            Each supplier brings different schemas, interfaces, and operational requirements. Building and maintaining individual integrations for dozens of sources creates complexity, increases integration costs, and slows your ability to respond to market changes. Enterprise travel organizations need a unified aggregation and orchestration layer.
          </p>
        </div>

        <div className="p-5  mt-5 shadow rounded">
          <h2
            className="text-center text-primary mb-5"
            style={{ fontSize: "28px" }}
          >
            TravelCarma Travel Data Xchange (TDX): Enterprise Supplier Integration & Orchestration
          </h2>

          <div className="row">
            <div className="col-lg-6 text-center">
              <img
                src={TDXIntro}
                alt="Enterprise Travel Connectivity and API Orchestration"
                style={{ width: "324px" }}
              />
            </div>
            <div className="col-lg-6 text-justify">
              <p style={{ fontSize: "1.17rem", lineHeight: "34px" }}>
                TDX is an enterprise-grade connectivity and orchestration platform that normalizes, aggregates, and routes content from multiple supplier sources—GDSs, consolidators, bedbanks, channel managers, and custom providers—through a single unified API and operational interface.
              </p>
              <p style={{ fontSize: "1.17rem", lineHeight: "34px" }}>
                TDX enables your team to manage supplier relationships, control data quality, orchestrate real-time feeds, and integrate with your existing booking, distribution, and legacy systems without reimplementing core logic.
              </p>
            </div>
          </div>
        </div>

        <h2 className="text-center mb-5 mt-5" style={{ fontSize: "28px" }}>
          TDX connects to all major travel supplier ecosystems
        </h2>

        <ul className="list-unstyled row tdx-boxes">
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>GDSs (Global Distribution
              Systems)
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>LCCs
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Consolidators
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Bedbanks
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Channel Managers
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Car Rental and Transfers
              Providers
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Bus Operators
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Sightseeing and Excursions
              Providers
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>DMCs
            </h5>
          </li>
          <li className="col-lg-6">
            <h5>
              <i className="material-icons"></i>Payment Gateways
            </h5>
          </li>
        </ul>

        <div className="text-center shadow rounded p-4 mb-5">
          <img
            src={TDXDiagram}
            className="w-100"
            alt="Travel Unified API Platform"
            style={{ maxWidth: "1500px" }}
          />
        </div>
      </div>

      <div className="mt-4 pt-5 pb-5" style={{ background: "#380085" }}>
        <div className="container">
          <p className="text-white text-center m-0">
            TDX includes pre-built connectors for over{" "}
            <Link
              to="/suppliers/travel-xml-api-integrations"
              className="text-primary"
            >
              80 global suppliers
            </Link>{" "}
            and{" "}
            <Link to={LowCostAirlines} target="_blank" className="text-primary">
              130+ low-cost carriers
            </Link>
            . For proprietary or custom suppliers not in our ecosystem, your team can extend TDX with our SDK or we can architect custom connectors as part of your implementation. Suppliers require commercial API agreements for activation.
          </p>
        </div>
      </div>

      <div className="container">
        <h2 className="text-center mb-5 mt-5" style={{ fontSize: "28px" }}>
          TDX Capabilities
        </h2>

        <div className="row solutions-section text-center">
          <div className="col-lg-8">
            <h2>Multi-Supplier Aggregation & Real-Time Orchestration</h2>
            <p>
              TDX aggregates content from multiple sources—flights, hotels, sightseeing, car rentals, transfers, rail, bus, and custom products—into a single operational interface. A unified API enables your application to retrieve real-time feeds from all active suppliers in a single request, normalized to your schema. TDX also manages payment gateway orchestration, allowing you to evolve payment providers without refactoring your booking logic.
            </p>
          </div>
          <div className="col-lg-4">
            <div>
              <img
                src={DiverseContent}
                alt="Multi-Supplier Aggregation and Integration"
                className="w-100"
              />
            </div>
          </div>
          <div className="solutions-separator"></div>

          {/* <div className="col-lg-4">
            <img
              src={BuildOwnAdapters}
              alt="Travel Unified API Platform - Adapters"
              className="w-100"
            />
          </div>
          <div className="col-lg-8">
            <h2>Supports Diverse Content</h2>
            <p>
              With TDX, you can integrate multiple products - flights, hotels,
              sightseeing, tours, car rentals, transfers, rail, bus, cruise and
              many more! With a single search request to TDX, you will get
              aggregated feeds from all the suppliers you've activated, on a
              real-time basis. What's more, we even have a payment gateway API
              with which you can add/change your payments provider without
              changing your application integration code
            </p>
          </div>
          <div className="solutions-separator"></div> */}

          <div className="col-lg-4">
            <img
              src={BuildOwnAdapters}
              alt="Custom Integration and Adapter Development"
              className="w-100"
            />
          </div>
          <div className="col-lg-8">
            <h2>Custom Integration & SDK-Based Extensibility</h2>
            <p>
              TDX provides SDKs and adapter frameworks enabling your engineering team to build and maintain custom connectors for proprietary or specialized suppliers. This approach reduces vendor lock-in, gives you operational control over your supply chain integrations, and accelerates time to integration for non-standard sources.
            </p>
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-8">
            <h2>Streamlined Integration & Operational Efficiency</h2>
            <p>
              Building and maintaining individual supplier integrations compounds over time—each supplier schema change, API upgrade, or feed issue requires separate code changes. TDX decouples your application from supplier interfaces through normalization and schema mapping, reducing the operational burden of supplier relationship management and freeing your team to focus on business logic rather than integration maintenance.
            </p>
          </div>
          <div className="col-lg-4">
            <img
              src={ReducedCost}
              alt="Operational Efficiency and Integration Management"
              className="w-100"
            />
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-4">
            <img
              src={ShorterTime}
              alt="Faster Supplier Onboarding and Operational Readiness"
              className="w-100"
            />
          </div>
          <div className="col-lg-8">
            <h2>Faster Supplier Onboarding & Operational Control</h2>
            <p>
              Rather than building supplier-specific integrations individually, TDX enables you to activate new suppliers within days. Once a supplier connector is available in TDX, activating their feeds into your distribution requires a single unified API call, not reimplementation of your booking logic. This accelerates your ability to respond to market opportunities and supplier partnerships.
            </p>
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-8">
            <h2>Channel Distribution & Partner Management</h2>
            <p>
              TDX enables you to distribute aggregated supplier content to B2B partners—resellers, sub-agencies, and distribution partners—through a unified API. Built-in channel management, pricing rules engines, and revenue controls let you manage margins, commissions, and business terms per channel. Partners connect once; your TDX instance handles all supplier normalization and orchestration, reducing their integration complexity and your operational overhead.
            </p>
          </div>
          <div className="col-lg-4">
            <img
              src={EaseOfDistribution}
              alt="Channel Distribution and Partner Management"
              className="w-100"
            />
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-4">
            <img
              src={Flexibility}
              alt="Schema Normalization and Legacy System Integration"
              className="w-100"
            />
          </div>
          <div className="col-lg-8">
            <h2>Schema Normalization & Legacy System Integration</h2>
            <p>
              TDX normalizes supplier data into formats compatible with your existing booking engine, CMS, or legacy systems without code changes. The platform transforms multi-format supplier schemas—XML, JSON, custom—into a unified output schema matching your application's data contracts. This enables you to integrate new suppliers, evolve your technology stack, or decouple from legacy systems incrementally, without wholesale platform replacement.
            </p>
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-8">
            <h2>Enterprise-Scale Performance & Operational Monitoring</h2>
            <p>
              TDX is architected for high-volume supplier orchestration with elastic scaling—automatically adjusting resources based on traffic patterns and supplier load. Hosted on AWS with multi-region deployment options, TDX maintains performance during peak travel periods while optimizing costs during off-peak hours. Built-in traffic analytics, feed monitoring, and anomaly detection provide operational visibility into supplier health, data quality, and integration performance. On-premise and private cloud deployments are available for regulated or compliance-sensitive operations.
            </p>
          </div>
          <div className="col-lg-4">
            <img
              src={TrafficVolumes}
              alt="Enterprise Performance and Operational Monitoring"
              className="w-100"
            />
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-4">
            <img
              src={MappedHotelInventory}
              alt="Intelligent Hotel Inventory Mapping and Deduplication"
              className="w-100"
            />
          </div>
          <div className="col-lg-8">
            <h2>Intelligent Hotel Inventory Mapping & Deduplication</h2>
            <p>
              Multi-supplier hotel inventory creates deduplication challenges—the same property represented differently across suppliers confuses booking engines and damages user experience. TDX includes intelligent mapping and deduplication, identifying and consolidating redundant inventory across sources, normalizing property data, and providing a unified view of available properties to your booking and distribution layers.
            </p>
          </div>
          <div className="solutions-separator"></div>

          <div className="col-lg-8">
            <h2>Feed Orchestration & Operational Controls</h2>
            <p>
              TDX provides fine-grained operational controls over supplier feeds and content distribution. Dynamically enable/disable feeds based on business rules—supplier balance thresholds, seasonal availability, route-specific sourcing, or pricing strategies. Intelligent feed orchestration routes searches to optimal suppliers based on destination, customer segment, or product type, minimizing operational costs while maintaining service quality. Revenue management controls let you apply dynamic pricing, margin rules, and channel-specific terms without rebuilding your booking logic.
            </p>
          </div>
          <div className="col-lg-4">
            <img
              src={FeedManagement}
              alt="Feed Orchestration and Operational Controls"
              className="w-100"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SolutionsTravelDataXchange;
